<template>
    <div>

                    <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);"
                         aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                            <li class="breadcrumb-item" @click.prevent="fetchCat(breadcrumb.parent,'home')"><a href="#"> 
                                <!-- <img src="assets/images/home-icon.svg" alt="" > -->Home
                            </a></li>
                            <li class="breadcrumb-item" aria-current="page" v-if="breadcrumb.parent" @click.prevent="fetchCat(breadcrumb.parent,'','parent')"><a href="#">{{breadcrumb.parent}}</a></li>
                            <li  class="breadcrumb-item active"    v-if="breadcrumb.child" @click.prevent="fetchCat(breadcrumb.parent,breadcrumb.child,'sub-category')"  aria-current="page"><a href="#">{{breadcrumb.child}}</a></li>
                            <li  class="breadcrumb-item active"  v-if="breadcrumb.product" aria-current="page">{{breadcrumb.product}}</li>
                        </ol>

                    </nav>
    </div>
</template>
<script>
import {mapGetters,mapActions} from 'vuex'
export default {
    computed:{
        ...mapGetters({
            breadcrumb:'Common/Breadcrumb',
            showroom:'Common/ShowRoom',
        })
    },

methods: {

        ...mapActions('Common',['updateCategory','updateBreadcrumb','setParentCategory','setSubCategory']),
    fetchCat(parentCatName,subcategory, type) {

        let loader = ''
        loader=this.$loading.show({
            container: this.$refs.aH_main_ref,
        });



        if(type==='parent'){

            const result = this.showroom.category.filter((word) => word.name === parentCatName);

            this.setParentCategory('')
           // this.setSubCategory('');

            this.updateCategory({
                parent: parentCatName,
                sub: '',
                list: result.length?result[0].children:[],
                type: type

            })

            this.updateBreadcrumb({
                parent:parentCatName,
                child:subcategory
            })

            loader.hide();
            this.$router.push('/visualize/contractor/' + parentCatName.toLowerCase()).catch(() => {})

        }else if(type==='sub-category'){

            
let result=''


            if(parentCatName!==''){
                 result = this.showroom.category.filter((word) => word.name === parentCatName);
            }else{
                 result = this.showroom.category.filter((word) => word.name === subcategory);
            }



            let subCat='';
           if(result.length>0){
               let subCat=result[0].children.filter((subName)=>subName.name===subcategory)
           }



            if(subCat.length>0){
                this.updateCategory({
                    parent:parentCatName,
                    sub:subcategory,
                    type:type,
                    list:subCat[0].children,
                })
            }else{



                this.updateCategory({
                    parent:parentCatName,
                    sub:subcategory,
                    type:type,
                    list:result[0].children.length>0 ? result[0].children:result[0],
                })
            }


            this.updateBreadcrumb({
                parent:parentCatName,
                child:subcategory
            })


            if(parentCatName!==''){
                this.$router.push('/visualize/contractor/' + parentCatName.toLowerCase()).catch(() => {})
            }else{
                this.$router.push('/visualize/contractor/' + subcategory.toLowerCase()).catch(() => {})
            }

        }else{ 


            const result = this.showroom.category



            this.updateCategory({
                parent:'',
                sub:'',
                type:type,
                list:result,
            })
           //
            this.updateBreadcrumb({
                parent:'',
                child:''
            })
           //
           //
            this.$router.push('/visualize/contractor/all').catch(() => {})

        }

        loader.hide();
    }
}
}
</script>
